<template>
  <div id="search">
    <input class="form-control" type="text" placeholder="Rechercher un lieu" v-model="keyword" @keyup.enter="sendSearch">
    <svg class="icon icon-search" aria-hidden="true" role="img">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-search"></use>
    </svg>
  </div>
</template>

<script>
  /* global dataLayer */
  /* eslint no-undef: "error" */
  
  import store from '../store/store'
  import json from '../store/jsonUrl'

  export default {
    name: 'search',
    data () {
      return {
        keyword: '',
        results: [],
        open: false
      }
    },
    methods: {
      sendSearch: function () {
        this.doSearchReq(this.openSearchPanel)
      },
      doSearchReq: function (callback) {
        if (store.cache.search[this.keyword] && store.cache.activate) {
          this.results = store.cache.search[this.keyword]
          if (callback !== null) {
            callback()
          }
        } else {
          this.$http.get(`${json.url.search}&s=${this.keyword}`).then((response) => {
            this.results = response.data
            this.$parent.keyword = this.keyword
            store.cache.search[this.keyword] = response.data
            dataLayer.push({
              'event': 'VirtualPageview',
              'virtualPageURL': '/?s=' + this.keyword,
              'virtualPageTitle': 'Recherche - ' + this.keyword
            })
          }, (response) => {
            console.log('error', response)
          }).then(_ => {
            if (callback !== null) {
              callback()
            }
          })
        }
      },
      openSearchPanel: function () {
        this.$parent.level = 2
        this.$parent.levelName = 'search'
        this.$parent.keyword = this.keyword
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Search.vue?03202d6d